import { render, staticRenderFns } from "./ihm.vue?vue&type=template&id=305a822d&scoped=true&v-once=true"
import script from "./ihm.vue?vue&type=script&lang=js"
export * from "./ihm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a822d",
  null
  
)

export default component.exports